/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = New
 *
 * 2 = Used
 *
 * 3 = Reclean
 *
 * 4 = Handover
 *
 * 5 = PaintProtection
 *
 * 6 = ServiceWash
 *
 * 7 = FullValeting
 *
 * 8 = Forecourt
 *
 * 9 = WorkshopCleaning
 */
export enum ValetingType {
  New = 1,
  Used = 2,
  Reclean = 3,
  Handover = 4,
  PaintProtection = 5,
  ServiceWash = 6,
  FullValeting = 7,
  Forecourt = 8,
  WorkshopCleaning = 9,
}
